import React, { useEffect, useState } from 'react';

import { Button, Container, Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => {
  return {
    buttonContainer: {
      marginTop: '30px',
    },
    closeIconContainer: {
      position: 'absolute',
      right: '24px',
      top: '24px',
    },
    container: {
      padding: '50px 40px',
      position: 'relative',
    },
    detailContainer: {
      marginTop: '30px',
    },
    message: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '1rem',
      textAlign: 'center',
    },

    subtitleContainer: {
      marginTop: '10px',
    },
    titleContainer: {
      marginTop: '16px',
    },

    topDetail: {
      marginBottom: '8px',
    },
    typographyDetail: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '20px',
    },
    typographySubtitle: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '24px',
    },
    typographyTitle: {
      color: theme.palette.primary.main,
      fontSize: '22px',
      fontWeight: 'bold',
      lineHeight: '24px',
    },
  };
});

export default ({ onCloseBtnAction, onBuyVideoReport, availableReport$ }) => {
  const classes = useStyles();
  const history = useHistory();
  const [availableReport, setAvailableReport] = useState(null);

  useEffect(() => {
    const availableReportSub = availableReport$.subscribe(setAvailableReport);
    return () => {
      availableReportSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestVideoReportClick = () => {
    history.push('/personalized-video');
    if (onCloseBtnAction) onCloseBtnAction();
  };

  return (
    <Container maxWidth="xs" disableGutters className={classes.container}>
      <div className={classes.closeIconContainer}>
        <IconButton onClick={onCloseBtnAction}>
          <CloseIcon />
        </IconButton>
      </div>

      <div className={classes.titleContainer}>
        <Typography className={`${classes.typographyTitle}`} align="center">
          Premium Coming Soon
        </Typography>
      </div>

      <div className={classes.subtitleContainer}>
        <Typography className={`${classes.typographySubtitle}`} align="center">
          Thank you for your interest in our premium self-help tools and content.
        </Typography>
      </div>

      <div className={classes.detailContainer}>
        <Typography className={`${classes.typographyDetail} ${classes.topDetail} text-left`}>
          Our premium content is currently under construction and will be available in the next few months.
        </Typography>

        <Typography className={`${classes.typographyDetail} text-left`}>
          Please check back here regularly for updates and consider purchasing one of our personalized video reports while you wait.
        </Typography>
      </div>

      <Grid container spacing={2} className={classes.buttonContainer} alignItems="center">
        <Grid item xs={12} sm={6}>
          <Button fullWidth variant="outlined" size="large" color="primary" onClick={onCloseBtnAction} className={classes.btn}>
            Back to Self-Help
          </Button>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Button fullWidth variant="contained" size="large" color="primary" onClick={handleRequestVideoReportClick} className={classes.btn}>
            {availableReport?.type ? 'Request Video Report' : 'Buy Video Report'}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
